import workspaceQuery from '../../../graphql/queries/web/WebMediaFolderWorkspaceQuery.graphql';
import instanceQuery from '../../../graphql/queries/web/WebMediaFolderQuery.graphql';
import defaultQuery from '../../../graphql/queries/web/WebMediaFolderDefault.graphql';
import mutationQuery from '../../../graphql/mutations/web/WebMediaFolderMutation.graphql';
import listQuery from '../../../graphql/queries/web/WebMediaFolderListQuery.graphql';
import fragment from '../../../graphql/fragments/web/WebMediaFolderFragment.graphql';
import { Direction } from '../../schema/p4types';

const WebMediaFolder = {
  type: 'WebMediaFolder',
  title: 'Web Media',
  formTitle: 'Web Media',
  formUrl: '/Web/Media/Details/',
  workspaceUrl: '/Web/Media/Treespace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  returnUrl: '/menu/Web',
  list: listQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'name',
    remoteFilter: true,
    preLoad: true,
    placeholder: 'Search media',
    customVariables: () => {
      return {
        orderBy: 'name',
        orderDirection: Direction.Asc,
        first: 50,
      };
    },
  },
  fragment,
  screenReference: 'WEB_MEDIA',
};

export default WebMediaFolder;
